import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login.component';
import { RouterModule } from '@angular/router';
import { CommonHeaderModule } from '../common-header/common-header.module';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { EmailMaskPipe } from './email-mask.pipe';
import { SnackbarComponent } from '../snackbar/snackbar.component';
import { MaterialModule } from '../material-module';

@NgModule({
  imports: [
    CommonModule,
    LoginRoutingModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    CommonHeaderModule,
    NgxSpinnerModule,
    MaterialModule,
  ],
  exports: [LoginComponent, ForgotPasswordComponent],
  declarations: [
    LoginComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    EmailMaskPipe,
  ],
  entryComponents: [SnackbarComponent],
})
export class LoginModule {}
